import { MessageContent, type SSERequest } from "./types";

export const prepareFormData = (input: SSERequest): FormData => {
  const formData = new FormData();
  formData.append("thread_id", input.thread_id);
  formData.append("message", input.message);
  if (input.app_state) {
    formData.append("app_state", JSON.stringify(input.app_state));
  }

  if (input.user_timezone) {
    formData.append("user_timezone", input.user_timezone);
  }

  if (input.user_locale) {
    formData.append("user_locale", input.user_locale);
  }

  if (input.viewport_is_mobile != null) {
    formData.append("viewport_is_mobile", String(input.viewport_is_mobile));
  }

  for (const file of input.message_attachments ?? []) {
    formData.append("message_attachments", file);
  }

  return formData;
};

export const hasMessageContent = (content: MessageContent): boolean => {
  if (content == null) return false;

  if (typeof content === "string") {
    return content.trim().length > 0;
  }

  if (Array.isArray(content)) {
    return content.length > 0;
  }

  // generic object: at least one truthy value
  return Object.values(content).some(Boolean);
};
